"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 5c7.18 0 11.722 6.441 11.911 6.716a.5.5 0 0 1-.029.607l-.315.355C22.293 14.072 17.404 19 12 19 5.839 19 .349 12.596.118 12.323a.502.502 0 0 1-.052-.572l.052-.074C.349 11.404 5.839 5 12 5Zm0 1c-4.946 0-9.637 4.709-10.828 6l.379.399C3.166 14.058 7.48 18 12 18c4.981 0 9.704-4.778 10.854-6.027l-.223-.276C21.341 10.134 17.418 6 12 6Zm0 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4Zm0 1c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3Z",
    clipRule: "evenodd"
  })]
});